import React from 'react';
import AsyncComponent from './components/AsyncComponent';

import Main from './routes/Main';

class App extends AsyncComponent {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  render() {
    return (
      <Main />
    );
  }
}

export default App;
